var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNmSankey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M477.66 0H22.3398C10.0019 0 0 10.0019 0 22.3398V477.66C0 489.998 10.0019 500 22.3398 500H477.66C489.998 500 500 489.998 500 477.66V22.3398C500 10.0019 489.998 0 477.66 0Z",
    fill: "#393A3A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2183_54327",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 22,
    width: 457,
    height: 456
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M478.248 22.0449H22.0459V477.953H478.248V22.0449Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2183_54327)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M458.848 98.1766H40.2705C30.2053 98.1766 22.0459 106.336 22.0459 116.401V383.303C22.0459 393.368 30.2053 401.528 40.2705 401.528H458.848C468.913 401.528 477.072 393.368 477.072 383.303V116.401C477.072 106.336 468.913 98.1766 458.848 98.1766Z",
    fill: "#1E1E1E",
    stroke: "#2B2B2B",
    strokeWidth: 0.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M458.848 -243.681H40.2705C30.2053 -243.681 22.0459 -235.522 22.0459 -225.457V41.4453C22.0459 51.5104 30.2053 59.6698 40.2705 59.6698H458.848C468.913 59.6698 477.072 51.5104 477.072 41.4453V-225.457C477.072 -235.522 468.913 -243.681 458.848 -243.681Z",
    fill: "#1E1E1E",
    stroke: "#2B2B2B",
    strokeWidth: 0.4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M460.024 440.622H40.2705C30.2053 440.622 22.0459 448.782 22.0459 458.847V715.461C22.0459 725.526 30.2053 733.685 40.2705 733.685H460.024C470.089 733.685 478.248 725.526 478.248 715.461V458.847C478.248 448.782 470.089 440.622 460.024 440.622Z",
    fill: "#1E1E1E",
    stroke: "#2B2B2B",
    strokeWidth: 0.4,
    strokeMiterlimit: 10
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.4892 138.742V122.281H242.798V138.742H68.4892Z",
    fill: "#3663AC",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.515 179.894C111.699 175.191 93.7685 171.664 68.4892 171.664V139.036C97.0019 139.036 118.754 142.857 136.684 149.324C154.615 155.497 167.843 164.021 179.012 171.664C181.364 173.134 183.422 174.897 185.479 176.367C203.704 189.301 216.343 198.119 242.505 198.119V230.747C204.88 230.747 184.303 216.05 165.785 202.822C163.727 201.352 161.67 199.883 159.612 198.413C149.618 191.358 139.33 184.891 125.515 180.188V179.894Z",
    fill: "#3663AC",
    fillOpacity: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.776 206.056C156.379 218.401 126.69 230.453 68.1953 230.453V181.364C117.578 181.364 139.33 171.664 157.554 162.552C159.612 161.376 161.67 160.494 163.727 159.318C182.54 149.324 204.292 138.742 242.505 138.742V187.243C216.931 187.243 205.174 193.416 187.243 202.528C185.185 203.704 182.834 204.88 180.482 206.056H180.776Z",
    fill: "#3663AC",
    fillOpacity: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.798 376.837H68.4892V230.453H242.798V376.837Z",
    fill: "#3663AC",
    fillOpacity: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9678 122.281H68.1953V171.37H54.9678V122.281Z",
    fill: "#3663AC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9678 181.364H68.1953V376.837H54.9678V181.364Z",
    fill: "#3663AC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M430.923 173.134H256.026V122.281H430.923V173.134Z",
    fill: "#45C0F0",
    fillOpacity: 0.3
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M376.543 360.67C348.913 368.901 317.46 376.837 256.026 376.837V197.825C295.121 197.825 308.936 193.71 321.576 189.889C321.87 189.889 322.457 189.889 322.751 189.595C323.339 189.595 323.927 189.301 324.221 189.007C348.031 181.658 376.543 173.134 431.217 173.134V352.146C403.586 352.146 394.18 355.085 379.777 359.495C378.601 359.789 377.425 360.376 375.955 360.67H376.543Z",
    fill: "#45C0F0",
    fillOpacity: 0.3
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M308.348 214.286C294.827 197.825 278.66 187.243 256.026 187.243V173.134C284.245 173.134 304.233 186.361 319.812 205.468C335.097 223.986 345.973 248.677 355.967 272.193C356.849 274.251 357.731 276.014 358.319 278.072C367.725 299.824 376.543 320.4 387.419 335.979C399.177 352.734 412.699 362.434 430.629 362.434V376.543C405.938 376.543 388.595 362.728 375.368 343.916C363.61 326.867 354.204 305.115 344.797 283.657C343.915 281.599 343.034 279.542 342.152 277.484C331.864 253.675 321.576 231.041 307.76 213.992L308.348 214.286Z",
    fill: "#45C0F0",
    fillOpacity: 0.3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M256.026 122.281H242.798V187.243H256.026V122.281Z",
    fill: "#45C0F0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M256.026 197.825H242.798V376.837H256.026V197.825Z",
    fill: "#45C0F0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M444.151 122.869H430.923V352.734H444.151V122.869Z",
    fill: "#52B163"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M444.151 363.022H430.923V377.131H444.151V363.022Z",
    fill: "#52B163"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNmSankey);
export default __webpack_public_path__ + "static/media/nm_sankey.52294094.svg";
export { ForwardRef as ReactComponent };